import React, { useEffect } from "react";
import "./RateCalcWidget.css";

const RateCalcWidget = () => {
  useEffect(() => {
    // Create script elements
    const scriptMain = document.createElement("script");
    scriptMain.src =
      "https://ratecalculator.grindanalytics.com/scripts/RC_Widget/main.min.js";
    const scriptApp = document.createElement("script");
    scriptApp.src =
      "https://ratecalculator.grindanalytics.com/scripts/RC_Widget/app.min.js";

    // Create link element for stylesheet
    const linkElement = document.createElement("link");
    linkElement.rel = "stylesheet";
    linkElement.href =
      "https://ratecalculator.grindanalytics.com/scripts/RC_Widget/main.css";

    // Append script and link elements to the document
    document.body.appendChild(scriptMain);
    document.body.appendChild(scriptApp);
    document.head.appendChild(linkElement);

    // Remove script and link from the document when the component unmounts
    return () => {
      document.body.removeChild(scriptMain);
      document.body.removeChild(scriptApp);
      document.head.removeChild(linkElement);
    };
  }, []);

  return <div id="RateCalc-Widget" ratecalc-company-key="hB69d78wxlE="></div>;
};

export default RateCalcWidget;
